// extracted by mini-css-extract-plugin
export var element = "TeamSection-module--element--0054a";
export var elementWrapper = "TeamSection-module--elementWrapper--728ec";
export var list = "TeamSection-module--list--00f6a";